import React from "react";
import { connect } from "react-redux";
import { nowString } from "lib/date";

import { isGuideOpen } from "state/school_money/selectors";
import { closeGuide } from "state/school_money/actions";

import WelcomeGuide from "components/WelcomeGuide";

import "./Guide.css";
import logoWithText from "components/assets/images/school_money/school_money-logo--text-right.svg";
import logoWithoutText from "components/assets/images/school_money/school_money-logo--no-text.svg";
import clubsIcon from "components/assets/images/school_money/guide/clubs.svg";
import dinnersIcon from "components/assets/images/school_money/guide/dinners.svg";
import historyIcon from "components/assets/images/school_money/guide/history.svg";
import paymentsIcon from "components/assets/images/school_money/guide/payments.svg";
import shopIcon from "components/assets/images/school_money/guide/shop.svg";
import parentalConsentIcon from "components/assets/images/school_money/guide/parental-consent.svg";

class Guide extends React.Component {
  
  render() {
    const { isOpen, onClose } = this.props;
    return (
      <WelcomeGuide cssModifier="school_money" logoPath={logoWithText} isOpen={isOpen} onClose={onClose}>
        <div className="school_money-guide-page">
          <div className="school_money-guide-page__icon">
            <img src={logoWithoutText} alt="SchoolMoney" />
          </div>
          <div className="school_money-guide-page__body">
            <div className="school_money-guide-page__title">Welcome!</div>
            <p>The SchoolMoney app has been designed with you - the parents and guardians - in mind. SchoolMoney allows you to make payments and bookings easily and securely, keeping all of your children’s information in one place no matter which school they attend.</p>
          </div>
        </div>
        <div className="school_money-guide-page">
          <div className="school_money-guide-page__icon">
            <img src={paymentsIcon} alt="payments" />
          </div>
          <div className="school_money-guide-page__body">
            <h1 className="school_money-guide-page__title">Payments</h1>
            <p>When your child’s school sends you payment requests, you can use the SchoolMoney app to manage these payments and make transactions at a time and place that suits you. To add an item to the basket, select the plus sign next to the relevant payment.</p>
          </div>
        </div>
        <div className="school_money-guide-page">
          <div className="school_money-guide-page__icon">
            <img src={dinnersIcon} alt="dinners" />
          </div>
          <div className="school_money-guide-page__body">
            <h1 className="school_money-guide-page__title">Dinners</h1>
            <p>The Dinners section of our app enables you to make top-ups or bookings onto your child’s dinner money account. From here you can manage your child’s meals, credits and debts.</p>
          </div>
        </div>
        <div className="school_money-guide-page">
          <div className="school_money-guide-page__icon">
            <img src={clubsIcon} alt="clubs" />
          </div>
          <div className="school_money-guide-page__body">
            <h1 className="school_money-guide-page__title">Clubs</h1>
            <p>The Clubs section allows you to manage any clubs that your child might attend such as breakfast or after school club. Through this section you can make payments, reservations and bookings for your child once the places open up.</p>
          </div>
        </div>
        <div className="school_money-guide-page">
          <div className="school_money-guide-page__icon">
            <img src={shopIcon} alt="shop" />
          </div>
          <div className="school_money-guide-page__body">
            <h1 className="school_money-guide-page__title">Shop</h1>
            <p>Within the shop, your child’s school can set up items for you to purchase online such as uniform, bookbags or concert DVDs. These items will sit in your account under Shop should you ever wish to purchase them.</p>
          </div>
        </div>
        <div className="school_money-guide-page">
          <div className="school_money-guide-page__icon">
            <img src={historyIcon} alt="history" />
          </div>
          <div className="school_money-guide-page__body">
            <h1 className="school_money-guide-page__title">History</h1>
            <p>Within the History section you will be able to see all of the transactions that you have made on the SchoolMoney system. This will show both online payments and any cash/cheque payments you may have made directly to the school.</p>
          </div>
        </div>
        <div className="school_money-guide-page">
          <div className="school_money-guide-page__icon">
            <img src={parentalConsentIcon} alt="parental consent" />
          </div>
          <div className="school_money-guide-page__body">
            <h1 className="school_money-guide-page__title">Parental Consent</h1>
            <p>The Parental Consent section of the app enables parents to view and manage the consent that they have given, or still need to give towards various trips/clubs. Parents can add consent as needed.</p>
          </div>
        </div>
      </WelcomeGuide>
    );
  }
  
}

export default connect(
  state => ({
    isOpen: isGuideOpen(state)
  }),
  {
    onClose: () => closeGuide(nowString())
  }
)(Guide);



// WEBPACK FOOTER //
// ./src/components/school_money/guide/Guide.js